import { Injectable } from '@angular/core';
import { CacheService } from '@df/core/cache/cache';
import { NDfs } from '../../dfs.interfaces';
import { DfsGlobalsService } from './../../core/dfs-globals.service';

export interface IDfsConfigParserOptions {
    source: string;
}

@Injectable({
    providedIn: 'any'
})
export class DfsRatioParserService implements NDfs.IParser {
    /**
     * Dependencies
     */
    constructor(private cacheService: CacheService) {}

    /**
     * Returns the value from string
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        return this.cacheService.get<NDfs.ICssEntry[]>(['dfs', 'ratioParser', dfs], () => {
            const match = dfs.match(/(\d+)(x|-|\/)(\d+)/);
            return [
                {
                    prop: rule.prop,
                    value: match ? `${match[1]} / ${match[3]}` : dfs
                }
            ];
        })!;
    }
}
